export const TRANSLATIONS = [
  'travel_tools_card_cabin_bag_guide_cta_label',
  'travel_tools_card_cabin_bag_guide_description',
  'travel_tools_card_cabin_bag_guide_name',
  'travel_tools_card_car_seat_map_category',
  'travel_tools_card_car_seat_map_cta_label',
  'travel_tools_card_car_seat_map_description',
  'travel_tools_card_car_seat_map_name',
  'travel_tools_card_cheapest_destinations_cta_label',
  'travel_tools_card_cheapest_destinations_description',
  'travel_tools_card_cheapest_destinations_name',
  'travel_tools_card_copy_paste_category',
  'travel_tools_card_copy_paste_cta_label',
  'travel_tools_card_copy_paste_description',
  'travel_tools_card_copy_paste_name',
  'travel_tools_card_european_road_trips_cta_label',
  'travel_tools_card_european_road_trips_description',
  'travel_tools_card_european_road_trips_name',
  'travel_tools_card_flight_tracker_cta_label',
  'travel_tools_card_flight_tracker_description',
  'travel_tools_card_flight_tracker_name',
  'travel_tools_card_running_map_cta_label',
  'travel_tools_card_running_map_description',
  'travel_tools_card_running_map_name',
  'travel_tools_card_sportscast_cta_label',
  'travel_tools_card_sportscast_description',
  'travel_tools_card_sportscast_name',
  'travel_tools_card_confidence_map_category',
  'travel_tools_card_confidence_map_cta_label',
  'travel_tools_card_confidence_map_description',
  'travel_tools_card_confidence_map_name',
  'travel_tools_card_grid_label',
  'travel_tools_card_round_trip_card_category',
  'travel_tools_card_round_trip_cta_label',
  'travel_tools_card_round_trip_description',
  'travel_tools_card_round_trip_name',
  'travel_tools_hero_title',
  'travel_tools_meta_description',
  'travel_tools_meta_title',
  'travel_tools_usp_ai_exploration_description',
  'travel_tools_usp_ai_exploration_title',
  'travel_tools_usp_curious_travellers_description',
  'travel_tools_usp_curious_travellers_title',
  'travel_tools_usp_data_insights_description',
  'travel_tools_usp_data_insights_title',
  'travel_tools_usp_early_tools_description',
  'travel_tools_usp_early_tools_title',
  'travel_confidence_map_meta_description',
  'travel_confidence_map_meta_title',
  'travel_confidence_map_one_way_label',
  'travel_confidence_map_pagination_label',
  'travel_confidence_map_pagination_next',
  'travel_confidence_map_pagination_page',
  'travel_confidence_map_pagination_previous',
  'travel_confidence_map_price_as_expected',
  'travel_confidence_map_price_cheaper',
  'travel_confidence_map_price_direct',
  'travel_confidence_map_price_more_expensive',
  'travel_confidence_map_price_disclaimer',
  'travel_confidence_map_stops_one_or_more',
  'travel_tools_not_found_go_back',
  'travel_tools_not_found_image_alt',
  'travel_tools_not_found_message',
  'travel_tools_not_found_title',
  'travel_confidence_map_cityName_and_countryName',
  'travel_confidence_map_airportName_and_airportCode',
  'travel_confidence_map_filter_from_label',
  'travel_confidence_map_hero_beta_label',
  'travel_confidence_map_hero_subtitle',
  'travel_confidence_map_hero_title',
  'travel_confidence_map_stat_cheaper_label',
  'travel_confidence_map_stat_expected_label',
  'travel_confidence_map_stat_expensive_label',
  'travel_confidence_map_show_on_map',
  'travel_confidence_map_show_as_list',
  'travel_confidence_map_where_from',
  'travel_confidence_map_search_placeholder',
  'travel_confidence_map_search_clear',
  'travel_confidence_map_filter_from_prefix',
  'travel_confidence_map_back',
  'travel_sky_map_breadcrumb_home',
  'travel_sky_map_breadcrumb_label',
  'travel_sky_map_breadcrumb_sky_map',
  'travel_sky_map_breadcrumb_travel_tools',
  'travel_sky_map_hero_title',
  'travel_sky_map_hero_description',
  'travel_sky_map_meta_title',
  'travel_sky_map_meta_description',
  'travel_sky_map_origin_selector_close',
  'travel_sky_map_origin_selector_label',
  'travel_sky_map_origin_selector_placeholder',
  'travel_sky_map_origin_selector_title',
  'travel_tools_card_sky_map_category',
  'travel_tools_card_sky_map_name',
  'travel_tools_card_sky_map_description',
  'travel_tools_card_sky_map_cta_label',
  'travel_sky_map_close_label',
  'travel_sky_map_status_label',
  'travel_sky_map_status_uncharted',
  'travel_sky_map_status_want_to_go',
  'travel_sky_map_status_explored',
  'travel_sky_map_uncharted_cta_want_to_visit',
  'travel_sky_map_uncharted_cta_mark_explored',
  'travel_sky_map_uncharted_empty_label',
  'travel_sky_map_explored_expeditions_title',
  'travel_sky_map_explored_add_expedition',
  'travel_sky_map_explored_no_expeditions',
  'travel_sky_map_explored_notes_title',
  'travel_sky_map_cheapest_time_title',
  'travel_sky_map_explored_first_visit',
  'travel_sky_map_explored_last_visit',
  'travel_sky_map_explored_stat_expeditions',
  'travel_sky_map_explored_stat_notes',
  'travel_sky_map_expedition_log_title',
  'travel_sky_map_expedition_arrival_label',
  'travel_sky_map_expedition_departure_label',
  'travel_sky_map_expedition_purpose_label',
  'travel_sky_map_expedition_add_button',
  'travel_sky_map_expedition_cancel_button',
  'travel_sky_map_expedition_delete_label',
  'travel_sky_map_expedition_purpose_leisure',
  'travel_sky_map_expedition_purpose_business',
  'travel_sky_map_expedition_purpose_family',
  'travel_sky_map_expedition_purpose_adventure',
  'travel_sky_map_expedition_purpose_education',
  'travel_sky_map_expedition_purpose_volunteering',
  'travel_sky_map_expedition_purpose_other',
  'travel_sky_map_want_to_go_title',
  'travel_sky_map_want_to_go_note_label',
  'travel_sky_map_want_to_go_note_placeholder',
  'travel_sky_map_want_to_go_desirability_label',
  'travel_sky_map_want_to_go_desirability_low',
  'travel_sky_map_want_to_go_desirability_medium',
  'travel_sky_map_want_to_go_desirability_high',
  'travel_sky_map_want_to_go_months_label',
  'travel_sky_map_want_to_go_months_placeholder',
  'travel_sky_map_want_to_go_target_year_label',
  'travel_sky_map_want_to_go_save_button',
  'travel_sky_map_want_to_go_move_to_explored',
  'travel_sky_map_want_to_go_month_flexible',
  'travel_sky_map_notes_saved',
  'travel_sky_map_legend_region_label',
  'travel_sky_map_legend_untracked',
  'travel_sky_map_legend_coverage_label',
  'road_trip_planner_meta_title',
  'road_trip_planner_meta_description',
  'road_trip_planner_car_class_fullsize',
  'road_trip_planner_car_class_unknown',
  'road_trip_planner_landing_meta_title',
  'road_trip_planner_landing_meta_description',
  'road_trip_planner_landing_city_explorer_prompt',
  'road_trip_planner_landing_city_explorer_title',
  'road_trip_planner_landing_faq_ai_answer',
  'road_trip_planner_landing_faq_ai_question',
  'road_trip_planner_landing_faq_borders_answer',
  'road_trip_planner_landing_faq_borders_question',
  'road_trip_planner_landing_faq_car_answer',
  'road_trip_planner_landing_faq_car_question',
  'road_trip_planner_landing_faq_cheapest_time_answer',
  'road_trip_planner_landing_faq_cheapest_time_question',
  'road_trip_planner_landing_faq_comparison_answer',
  'road_trip_planner_landing_faq_comparison_question',
  'road_trip_planner_landing_faq_documents_answer',
  'road_trip_planner_landing_faq_documents_question',
  'road_trip_planner_landing_faq_driver_answer',
  'road_trip_planner_landing_faq_driver_question',
  'road_trip_planner_landing_faq_ev_answer',
  'road_trip_planner_landing_faq_ev_question',
  'road_trip_planner_landing_faq_free_answer',
  'road_trip_planner_landing_faq_free_question',
  'road_trip_planner_landing_faq_insurance_answer',
  'road_trip_planner_landing_faq_insurance_question',
  'road_trip_planner_landing_faq_mileage_answer',
  'road_trip_planner_landing_faq_mileage_question',
  'road_trip_planner_landing_faq_one_way_answer',
  'road_trip_planner_landing_faq_one_way_question',
  'road_trip_planner_landing_faq_route_answer',
  'road_trip_planner_landing_faq_route_question',
  'road_trip_planner_landing_faq_title',
  'road_trip_planner_landing_hero_breadcrumb_home',
  'road_trip_planner_landing_hero_breadcrumb_current',
  'road_trip_planner_landing_hero_empty_prompt_error',
  'road_trip_planner_landing_hero_guidance_prefix',
  'road_trip_planner_landing_hero_mobile_unavailable_message',
  'road_trip_planner_landing_hero_prompt_label',
  'road_trip_planner_landing_hero_prompt_placeholder',
  'road_trip_planner_landing_hero_start_planning',
  'road_trip_planner_landing_hero_subtitle',
  'road_trip_planner_landing_hero_title_first_line',
  'road_trip_planner_landing_hero_title_second_line',
  'road_trip_planner_landing_hero_too_long_prompt_error',
  'road_trip_planner_landing_planning_tips_budget_description',
  'road_trip_planner_landing_planning_tips_budget_title',
  'road_trip_planner_landing_planning_tips_flexibility_description',
  'road_trip_planner_landing_planning_tips_flexibility_title',
  'road_trip_planner_landing_planning_tips_local_laws_description',
  'road_trip_planner_landing_planning_tips_local_laws_title',
  'road_trip_planner_landing_planning_tips_search_description',
  'road_trip_planner_landing_planning_tips_search_title',
  'road_trip_planner_landing_planning_tips_title',
  'road_trip_planner_page_all_cars_cta',
  'road_trip_planner_page_car_feature_automatic',
  'road_trip_planner_page_car_feature_electric',
  'road_trip_planner_page_car_feature_hybrid',
  'road_trip_planner_page_car_feature_manual',
  'road_trip_planner_page_car_hire_pick_up_location',
  'road_trip_planner_page_car_hire_recommaned_reason_title',
  'road_trip_planner_page_car_hire_recommended_cars',
  'road_trip_planner_page_car_type_all_terrain_vehicle',
  'road_trip_planner_page_car_type_commercial_van',
  'road_trip_planner_page_car_type_compact',
  'road_trip_planner_page_car_type_compact_suv',
  'road_trip_planner_page_car_type_economy',
  'road_trip_planner_page_car_type_economy_suv',
  'road_trip_planner_page_car_type_estate',
  'road_trip_planner_page_car_type_fullsize',
  'road_trip_planner_page_car_type_fullsize_commercial_van',
  'road_trip_planner_page_car_type_fullsize_estate',
  'road_trip_planner_page_car_type_fullsize_passenger_van',
  'road_trip_planner_page_car_type_fullsize_suv',
  'road_trip_planner_page_car_type_intermediate',
  'road_trip_planner_page_car_type_intermediate_passenger_van',
  'road_trip_planner_page_car_type_intermediate_suv',
  'road_trip_planner_page_car_type_limousine',
  'road_trip_planner_page_car_type_mini',
  'road_trip_planner_page_car_type_mini_passenger_van',
  'road_trip_planner_page_car_type_motorcycle',
  'road_trip_planner_page_car_type_or_similar',
  'road_trip_planner_page_car_type_pick_up_truck',
  'road_trip_planner_page_car_type_premium',
  'road_trip_planner_page_car_type_premium_convertible',
  'road_trip_planner_page_car_type_premium_coupe',
  'road_trip_planner_page_car_type_premium_estate',
  'road_trip_planner_page_car_type_premium_passenger_van',
  'road_trip_planner_page_car_type_premium_sports_car',
  'road_trip_planner_page_car_type_premium_suv',
  'road_trip_planner_page_car_type_sports_car',
  'road_trip_planner_page_car_type_standard',
  'road_trip_planner_page_car_type_standard_passenger_van',
  'road_trip_planner_page_car_type_standard_suv',
  'road_trip_planner_page_chat_changes_prompt',
  'road_trip_planner_page_chat_info_accuracy_disclaimer',
  'road_trip_planner_page_chat_info_data_use_notice',
  'road_trip_planner_page_chat_info_learn_more',
  'road_trip_planner_page_chat_info_powered_by_ai',
  'road_trip_planner_page_chat_route_prompt',
  'road_trip_planner_page_chat_starting_point_prompt',
  'road_trip_planner_page_chat_thinking_status',
  'road_trip_planner_page_chat_title',
  'road_trip_planner_page_chat_travellers_prompt',
  'road_trip_planner_page_chat_vibe_prompt',
  'road_trip_planner_page_chat_write_answer',
  'road_trip_planner_page_generic_error',
  'road_trip_planner_page_indicative_offers_title',
  'road_trip_planner_page_indicative_price_per_day',
  'road_trip_planner_page_indicative_show_more',
  'road_trip_planner_page_itinerary_coverage_good',
  'road_trip_planner_page_itinerary_coverage_limited',
  'road_trip_planner_page_itinerary_coverage_well_covered',
  'road_trip_planner_page_itinerary_day_count',
  'road_trip_planner_page_itinerary_day_label',
  'road_trip_planner_page_itinerary_days_count',
  'road_trip_planner_page_itinerary_distance_label',
  'road_trip_planner_page_itinerary_driving_label',
  'road_trip_planner_page_itinerary_duration_hours_minutes',
  'road_trip_planner_page_itinerary_estimated_cost',
  'road_trip_planner_page_itinerary_estimated_driving_duration',
  'road_trip_planner_page_itinerary_ev_charging_label',
  'road_trip_planner_page_itinerary_fuel_label',
  'road_trip_planner_page_itinerary_km',
  'road_trip_planner_page_itinerary_longest_driving_day_label',
  'road_trip_planner_page_itinerary_pick_car',
  'road_trip_planner_page_itinerary_tolls_label',
  'road_trip_planner_page_live_offers_free_cancellation',
  'road_trip_planner_page_live_offers_go_to_site',
  'road_trip_planner_page_live_offers_non_refundable',
  'road_trip_planner_page_live_offers_total',
  'road_trip_planner_page_price_drawer_empty_guidance',
  'road_trip_planner_page_price_drawer_empty_title',
  'road_trip_planner_page_price_drawer_error_title',
  'road_trip_planner_page_price_drawer_insights_title',
  'road_trip_planner_page_price_drawer_retry',
  'road_trip_planner_page_price_drawer_success_title',
  'road_trip_planner_page_progress_checking_trip_vibe',
  'road_trip_planner_page_progress_finding_travel_dates',
  'road_trip_planner_page_progress_identifying_travellers',
  'road_trip_planner_page_progress_working_out_route',
  'road_trip_planner_page_route_label',
  'road_trip_planner_page_vehicle_category_compact',
  'road_trip_planner_page_vehicle_category_economy',
  'road_trip_planner_page_vehicle_category_intermediate',
  'road_trip_planner_page_vehicle_category_mini',
  'road_trip_planner_page_vehicle_category_people_carrier',
  'road_trip_planner_page_vehicle_category_premium',
  'road_trip_planner_page_vehicle_category_suv',
  'road_trip_planner_page_vehicle_doors_2_3',
  'road_trip_planner_page_vehicle_doors_4_5',
  'hana_trip_type_selection_title',
  'hana_trip_type_list_label',
  'hana_trip_type_chill_and_relax_name',
  'hana_trip_type_chill_and_relax_description',
  'hana_trip_type_foodie_adventure_name',
  'hana_trip_type_foodie_adventure_description',
  'hana_trip_type_first_timers_name',
  'hana_trip_type_first_timers_description',
  'hana_trip_type_cultural_explorers_name',
  'hana_trip_type_cultural_explorers_description',
  'hana_trip_type_must_see_name',
  'hana_trip_type_must_see_description',
  'hana_trip_detail_back',
  'hana_trip_detail_hero_image_alt',
  'hana_trip_detail_title',
  'hana_trip_detail_highlights_title',
  'hana_trip_detail_highlights_label',
  'hana_trip_detail_day_plan_title',
  'hana_trip_detail_where_to_stay_title',
  'hana_trip_detail_where_to_stay_label',
  'hana_trip_detail_neighbourhood_reviews',
  'hana_trip_detail_neighbourhood_distance',
  'hana_trip_detail_neighbourhood_reviews_label',
  'hana_trip_detail_neighbourhood_price_average',
  'hana_trip_detail_select_trip',
  'hana_trip_detail_highlight_cn_tower',
  'hana_trip_detail_highlight_distillery_district',
  'hana_trip_detail_highlight_high_park',
  'hana_trip_detail_highlight_trinity_bellwoods_park',
  'hana_trip_detail_highlight_casa_loma',
  'hana_trip_detail_highlight_graffiti_alley',
  'hana_trip_detail_day_1_title',
  'hana_trip_detail_day_1_description',
  'hana_trip_detail_day_2_title',
  'hana_trip_detail_day_2_description',
  'hana_trip_detail_day_3_title',
  'hana_trip_detail_day_3_description',
  'hana_trip_detail_day_4_title',
  'hana_trip_detail_day_4_description',
  'hana_trip_detail_day_5_title',
  'hana_trip_detail_day_5_description',
  'hana_trip_detail_neighbourhood_downtown_core_name',
  'hana_trip_detail_neighbourhood_kensington_market_name',
  'hana_trip_detail_neighbourhood_the_annex_name',
  'hana_meta_title',
  'hana_meta_description',
  'hana_page_title',
  'hana_chat_label',
  'hana_chat_transcript_label',
  'hana_chat_trip_title',
  'hana_chat_trip_subtitle',
  'hana_chat_trip_summary_dates',
  'hana_chat_trip_summary_stays',
  'hana_chat_trip_kind_question',
  'hana_chat_trip_kind_answer',
  'hana_chat_trip_kind_options_label',
  'hana_chat_trip_kind_family',
  'hana_chat_trip_kind_couple',
  'hana_chat_trip_kind_solo',
  'hana_chat_trip_kind_foodie',
  'hana_chat_composer_trip_kind_placeholder',
  'hana_chat_pick_trip_type',
  'hana_chat_composer_placeholder',
  'hana_chat_composer_add',
  'hana_chat_composer_sending',
  'hana_chat_error',
  'hana_chat_plan_steps_label',
  'hana_chat_plan_step_creating',
  'hana_chat_plan_step_attractions',
  'hana_chat_plan_step_neighbourhoods',
  'hana_chat_plan_step_deals',
  'hana_chat_see_plan',
  'hana_chat_composer_minimized',
  'hana_trip_plan_hot_spots_title',
  'hana_trip_plan_hot_spots_label',
  'hana_trip_plan_shortlist_title',
  'hana_trip_plan_stay_price',
  'hana_trip_plan_stay_remove',
  'hana_trip_plan_itinerary_title',
  'hana_trip_plan_see_full_plan',
  'hana_neighbourhoods_title',
  'hana_neighbourhoods_price_range',
  'hana_neighbourhoods_price_intro',
  'hana_neighbourhoods_price_label',
  'hana_neighbourhoods_list_label',
  'hana_neighbourhoods_description',
  'hana_neighbourhoods_details_cta',
  'hana_panel_back',
  'hana_panel_close',
  'hana_panel_show',
  'hana_neighbourhood_detail_label',
  'hana_neighbourhood_detail_name',
  'hana_neighbourhood_detail_location',
  'hana_neighbourhood_detail_gallery_label',
  'hana_neighbourhood_detail_view_photos',
  'hana_neighbourhood_detail_why_title',
  'hana_neighbourhood_detail_why_body',
  'hana_neighbourhood_detail_explore_cta',
  'hana_nearby_title',
  'hana_nearby_list_label',
  'hana_nearby_platja_fonda',
  'hana_nearby_toc_al_mar',
  'hana_nearby_castell_de_begur',
  'hana_nearby_sa_riera_village',
  'hana_nearby_cap_de_begur_lighthouse',
  'hana_nearby_category_beach',
  'hana_nearby_category_restaurant',
  'hana_nearby_category_attraction',
  'hana_nearby_rating',
  'hana_nearby_rating_label',
  'hana_nearby_distance_metres',
  'hana_nearby_distance_kilometres',
  'hana_hotels_label',
  'hana_hotels_list_label',
  'hana_hotels_neighbourhood_name',
  'hana_hotels_cheaper_than_usual',
  'hana_hotels_rating_out_of',
  'hana_hotels_rating_label',
  'hana_hotels_reviews',
  'hana_hotels_star_rating',
  'hana_hotels_deals_from',
  'hana_hotels_save',
  'hana_hotels_see_more',
  'hana_hotel_detail_label',
  'hana_hotel_detail_name',
  'hana_hotel_detail_star_rating',
  'hana_hotel_detail_rating_title',
  'hana_hotel_detail_reviews',
  'hana_hotel_detail_rating_label',
  'hana_hotel_detail_location',
  'hana_hotel_detail_gallery_label',
  'hana_hotel_detail_view_photos',
  'hana_hotel_detail_review_summary',
  'hana_hotel_detail_summarised_by_ai',
  'hana_hotel_photos_categories_label',
  'hana_hotel_photos_category_traveller',
  'hana_hotel_photos_category_all',
  'hana_hotel_photos_category_official',
  'hana_hotel_photos_category_bedroom',
  'hana_hotel_photos_category_pool',
  'hana_hotel_photos_category_dining',
  'hana_hotel_photos_category_bar',
  'hana_hotel_photos_category_terrace',
  'hana_hotel_photos_category_gym',
  'hana_hotel_photos_photo_label',
  'hana_hotel_photos_previous',
  'hana_hotel_photos_next',
  'hana_hotel_photos_counter',
  'hana_hotel_photos_thumbnails_label',
  'hana_hotel_deals_title',
  'hana_hotel_deals_subtitle',
  'hana_hotel_deals_list_label',
  'hana_hotel_deals_cheapest',
  'hana_hotel_deals_non_refundable',
  'hana_hotel_deals_double_room',
  'hana_hotel_deals_no_meals',
  'hana_hotel_deals_go_to_site',
  'hana_hotel_deals_view_more',
  'hana_breadcrumbs_label',
  'hana_breadcrumbs_home',
  'hana_breadcrumbs_travel_tools',
  'hana_breadcrumbs_current',
  'hana_map_label',
  'hana_map_marker_label',
  'hana_landing_headline',
  'hana_landing_subtitle',
  'hana_landing_disclaimer',
  'hana_landing_disclaimer_link',
] as const;

export const TRANSLATION_KEYS_SET = new Set<string>(TRANSLATIONS);

export type TranslationKey = (typeof TRANSLATIONS)[number];
